import { connect } from "react-redux";
import get from "lodash/get";

import {
  getRoutes as onGetRoutes,
  createRoute as onCreateRoute,
  deleteRoute as onDeleteRoute,
  changeSearchTerm as onChangeSearchTerm,
  changeOrderDesc as onChangeOrderDesc,
  selectRoute as onSelectRoute,
  unselectRoute as onUnselectRoute,
} from "./../../actions/routesActions";

import {
  createTrip as onCreateTrip,
  deleteTrip as onDeleteTrip,
  updateTripControlPoints as onUpdateTripControlPoints,
  selectTrip as onSelectTrip,
  unselectTrip as onUnselectTrip,
  createTripUnit as onCreateTripUnit,
  deleteTripUnit as onDeleteTripUnit,
} from "./../../actions/tripsActions";

const mapStateToProps = (state) => ({
  routesDataState: state.routes.routesDataState,
  createRouteDataState: state.routes.createRouteDataState,
  deleteRouteDataState: state.routes.deleteRouteDataState,
  createRouteTripDataState: state.routes.createRouteTripDataState,
  deleteRouteTripDataState: state.routes.createRouteTripDataState,
  updateTripControlPoints: state.routes.updateTripControlPoints,
  createTripUnitDataState: state.routes.createTripUnitDataState,
  deleteTripUnitDataState: state.routes.deleteTripUnitDataState,
  routes: get(state, ["routes", "routes"], []),
  totalCount: get(state, ["routes", "totalCount"], 0),
  count: get(state, ["routes", "count"], 0),
  selectedRouteId: get(state, ["routes", "selectedRouteId"], null),
  selectedTripId: get(state, ["routes", "selectedTripId"], null),
  selectedTripUnitId: get(state, ["routes", "selectedTripUnitId"], null),
  requestOptions: get(state, ["routes", "requestOptions"], null),
});

const mapDispatchToProps = {
  onGetRoutes,
  onCreateRoute,
  onDeleteRoute,
  onChangeSearchTerm,
  onChangeOrderDesc,
  onSelectRoute,
  onUnselectRoute,
  onCreateTrip,
  onDeleteTrip,
  onUpdateTripControlPoints,
  onSelectTrip,
  onUnselectTrip,
  onCreateTripUnit,
  onDeleteTripUnit,
};

const withRoutes = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRoutes };
